import React, { useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Box,
  Snackbar,
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { partyCreate, partyList } from "../../../Services/Services"; // adjust path

const AddParty = ({ setParties, setOpenAddModal }) => {
  const [partyDetails, setPartyDetails] = useState({
    name: "",
    contact_no: "",
    contact_no1: "",
    contact_no2: "",
    address: "",
    gst_no: "",
    pan_no: "",
    commission: "",
  });

  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [duplicateParty, setDuplicateParty] = useState(null); // store existing party
  const [openDuplicateDialog, setOpenDuplicateDialog] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;
    const updatedErrors = { ...errors };

    if (name.includes("contact_no")) {
      newValue = value.replace(/\D/g, ""); // digits only
    }
    if (name === "gst_no") newValue = value.toUpperCase().slice(0, 15);
    if (name === "pan_no") newValue = value.toUpperCase().slice(0, 10);

    setPartyDetails({ ...partyDetails, [name]: newValue });
    setErrors(updatedErrors);
  };

  const validateInputs = () => {
    const { contact_no, gst_no, pan_no } = partyDetails;
    const validationErrors = {};

    if (!/^\d{10}$/.test(contact_no))
      validationErrors.contact_no = "Contact number must be exactly 10 digits.";
    if (
      gst_no &&
      !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gst_no)
    )
      validationErrors.gst_no = "Invalid GST No format.";
    if (pan_no && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan_no))
      validationErrors.pan_no = "Invalid PAN No format.";

    return validationErrors;
  };

  const checkDuplicate = async () => {
    try {
      const allParties = await partyList();
      const duplicate = allParties.find(
        (p) =>
          p.name.toLowerCase().trim() === partyDetails.name.toLowerCase().trim()
      );
      if (duplicate) {
        setDuplicateParty(duplicate);
        setOpenDuplicateDialog(true);
        return true;
      }
      return false;
    } catch (error) {
      console.error("Error fetching parties:", error);
      return false;
    }
  };

  // console.log("Sending party details:", partyDetails);

  //   try {
  //   const partyCreateResponse =  partyCreate(partyDetails);
  //   setParties(prev => [...prev, partyCreateResponse]);
  // } catch (error) {
  //   console.log(error.response.data); // backend se exact validation message milega
  //   setSnackbar({
  //     open: true,
  //     message: 'Failed to add party: ' + (error.response?.data?.name || ''),
  //     severity: 'error',
  //   });
  // }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateInputs();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const isDuplicate = await checkDuplicate();
    if (!isDuplicate) {
      // No duplicate, create directly
      await saveParty();
    }
  };

  const saveParty = async (force = false) => {
    try {
      await partyCreate({ ...partyDetails, force }); // add party

      // Backend se latest party list fetch karo
      const latestParties = await partyList();
      setParties(latestParties); // state update
      setOpenAddModal(false);
      setPartyDetails({
        name: "",
        contact_no: "",
        contact_no1: "",
        contact_no2: "",
        address: "",
        gst_no: "",
        pan_no: "",
        commission: "",
      });
      setSnackbar({
        open: true,
        message: "Party added successfully!",
        severity: "success",
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to add party.",
        severity: "error",
      });
    }
  };

  return (
    <Box className="form-container-party">
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Party Name"
              name="name"
              value={partyDetails.name}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Contact No"
              name="contact_no"
              value={partyDetails.contact_no}
              onChange={handleChange}
              required
              error={!!errors.contact_no}
              helperText={errors.contact_no}
              inputProps={{ maxLength: 10 }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Alternate Mobile Number"
              name="contact_no1"
              value={partyDetails.contact_no1}
              onChange={handleChange}
              inputProps={{ maxLength: 10 }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Alternate Mobile Number"
              name="contact_no2"
              value={partyDetails.contact_no2}
              onChange={handleChange}
              inputProps={{ maxLength: 10 }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Munsiyana"
              name="commission"
              value={partyDetails.commission}
              onChange={handleChange}
              required
              type="number"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Address"
              name="address"
              value={partyDetails.address}
              onChange={handleChange}
              multiline
              rows={2}
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="GST No"
              name="gst_no"
              value={partyDetails.gst_no}
              onChange={handleChange}
              inputProps={{ maxLength: 15 }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="PAN No"
              name="pan_no"
              value={partyDetails.pan_no}
              onChange={handleChange}
              inputProps={{ maxLength: 10 }}
            />
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" type="submit">
              Add Party
            </Button>
          </Grid>
        </Grid>
      </form>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* Duplicate Dialog */}
      <Dialog
        open={openDuplicateDialog}
        onClose={() => setOpenDuplicateDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Duplicate Party Found</DialogTitle>
        <DialogContent dividers>
          <Box>
            <p>A party with this name already exists. Here are the details:</p>
            <p>
              <strong>Name:</strong> {duplicateParty?.name}
            </p>
            <p>
              <strong>Contact No:</strong> {duplicateParty?.contact_no}
            </p>
            <p>
              <strong>Alternate No 1:</strong> {duplicateParty?.contact_no1}
            </p>
            <p>
              <strong>Alternate No 2:</strong> {duplicateParty?.contact_no2}
            </p>
            <p>
              <strong>Address:</strong> {duplicateParty?.address}
            </p>
            <p>
              <strong>GST No:</strong> {duplicateParty?.gst_no}
            </p>
            <p>
              <strong>PAN No:</strong> {duplicateParty?.pan_no}
            </p>
            <p>
              <strong>Munsiyana:</strong> {duplicateParty?.commission}
            </p>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDuplicateDialog(false)} color="error">
            Close
          </Button>
          <Button
            onClick={() => {
              setOpenDuplicateDialog(false);
              saveParty(true); // <-- yaha force=true pass kiya
            }}
            color="primary"
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AddParty;
